import React, {useState, useEffect} from "react";

export default function LatzhosePrimoBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M316.114,259.466c-0.063-2.995-0.125-5.861-0.173-8.566c-0.628-31.822-2.816-51.234-4.653-58.792
		c-0.339-1.387-0.567-2.837-0.663-4.294c-0.049-0.67-0.062-1.353-0.084-2.009c-0.014-0.641-0.028-1.311-0.069-1.967
		c-0.193-2.927-0.297-5.902-0.4-8.787l-0.035-1.069c-0.028-0.815-0.041-1.657-0.048-2.5c-0.028-2.367-0.055-4.818-0.512-7.102
		c-0.407-2.036-1.353-3.872-2.264-5.647c-0.345-0.67-0.697-1.36-1.015-2.05c-0.766-1.643-1.429-3.334-2.154-5.225
		c-1.574-4.1-3.03-8.373-4.335-12.701l-0.29-0.953c-1.083-3.597-2.209-7.309-2.464-11.018c-0.402-5.955-0.689-19.009-0.805-25.128
		l0.258-3.32l-7.733-1.718l-13.441,0.005l-5.027,2.151l-2.16-0.446l-22.45,1.456l-12.337-1.887l-20.333-1.508l-8.786,2.143
		l-0.729,13.979c-0.143,5.34-0.333,10.928-0.561,14.273c-0.228,3.397-1.18,6.8-2.106,10.093l-0.131,0.462
		c-1.291,4.604-2.767,9.098-4.397,13.35c-1.014,2.664-2.194,5.288-3.5,7.786c-0.152,0.297-0.303,0.587-0.448,0.863
		c-1.229,2.305-2.203,4.128-1.982,6.979c0.359,4.687,0.311,9.561-0.138,15.352c-0.076,0.994-0.117,2.002-0.159,2.975
		c-0.041,1.042-0.082,2.112-0.173,3.168c-0.173,2.071-0.483,4.135-0.917,6.13l-0.083,0.366c-2.5,10.893-4.274,32.049-4.757,56.59
		c-0.18,9.188-0.435,20.191-0.697,31.843c-0.959,41.81-2.036,89.206-0.925,94.77c0.545,2.754,0.642,18.32,0.752,36.344
		c0.173,28.764,0.387,64.562,2.513,70.312l0.035,0.097l0.103,0.033c0.131,0.042,9.306,2.796,23.532,2.796
		c7.158,0,15.594-0.697,24.803-2.789c0.22,0,0.22,0,0.414-3.541c0.117-2.126,0.283-5.163,0.469-8.801
		c0.387-7.289,0.884-17.009,1.381-26.721c0.988-19.439,1.967-38.87,1.967-38.87c0.028-0.573,2.437-57.867,1.837-81.599
		c0.801-18.079,5.032-35.591,5.087-35.812c0.186-4.957,0.63-11.049,1.323-16.158h0.048v-0.347c0.789-5.671,1.89-10.049,3.294-10.147
		c2.63,0.186,4.198,15.331,4.646,25.976c-0.007,0.124-0.007,0.214-0.007,0.228h0.021c0.007,0.166,0.014,0.331,0.021,0.489
		c0.041,0.18,4.272,17.693,5.08,35.758c-0.607,23.746,1.802,81.04,1.83,81.613c0,0,0.979,19.432,1.967,38.87
		c0.497,9.712,1.001,19.432,1.381,26.721c0.193,3.638,0.352,6.675,0.469,8.801c0.193,3.541,0.2,3.541,0.373,3.541
		c9.229,2.092,17.678,2.789,24.844,2.789c14.234,0,23.401-2.754,23.54-2.796l0.096-0.033l0.041-0.097
		c2.126-5.75,2.341-41.555,2.513-70.32c0.103-18.024,0.2-33.583,0.752-36.337c1.112-5.564,0.028-52.98-0.931-94.811
		C316.444,274.501,316.265,266.618,316.114,259.466z"
        />
        <path
          fill="#151515"
          d="M300.539,161.995c0,0,11.238,42.463,12.819,43.943l-2.823-17.156l-0.516-7.016c0,0-0.361-7.62-0.12-8.536
		c0.241-0.916-0.299-7.979-0.299-7.979l-0.223-0.648C309.378,164.603,300.908,162.118,300.539,161.995z"
        />
        <path
          fill="#151515"
          d="M199.492,161.817c0,0-10.551,42.212-12.132,43.693c0,0,2.902-19.491,2.72-24.256
		c0,0,0.856-7.765,0.615-8.681c-0.241-0.916-0.264-7.5-0.264-7.5l0.222-0.648C190.654,164.425,199.123,161.939,199.492,161.817z"
        />
        <polygon
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          points="194.571,195.166 243.384,196.033 243.118,211.276 238.024,215.854 199.181,215.213 194.29,210.385 
			"
        />
        <polygon
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          points="307.178,195.161 258.366,196.028 258.631,211.271 263.725,215.849 302.569,215.208 307.459,210.38 
			"
        />
        <path
          fill="#010101"
          d="M215.766,62.133l-15.084,0.96l0.525,7.338l0.097,0.055c0.11,0.062,2.499,1.457,6.481,1.457
		c0.304,0,0.607-0.007,0.925-0.028c4.529-0.242,7.373-1.967,7.49-2.043l0.11-0.069L215.766,62.133z M208.691,71.487
		c-3.935,0.214-6.551-1.042-7.075-1.318l-0.476-6.675l14.227-0.911l0.503,6.993C215.304,69.892,212.611,71.28,208.691,71.487"
        />
        <path
          fill="#303030"
          d="M217.664,62.071c-0.069-0.772-0.704-1.401-1.478-1.477l-1.491,0.089v0.153l-12.804,0.738l0.014-0.373
		l-0.345,0.035l-1.153,0.082c-0.435,0.008-0.835,0.083-1.188,0.215c-0.476,0.179-0.773,0.642-0.746,1.153
		c0.525,8.663,1.202,18.976,1.395,19.528c0.255,0.649,1.001,0.925,1.401,1.035l-0.242-3.411l16.332-1.042l0.255,3.569
		c0.566-0.248,1.298-0.649,1.436-0.974C219.162,80.909,218.631,73.503,217.664,62.071 M216.201,69.872
		c-0.117,0.075-2.961,1.801-7.49,2.043c-0.318,0.021-0.621,0.028-0.924,0.028c-3.983,0-6.371-1.395-6.482-1.456l-0.097-0.055
		l-0.524-7.338l15.083-0.96l0.545,7.668L216.201,69.872z"
        />
        <path
          fill="#303030"
          d="M300.596,61.533c-0.352-0.131-0.752-0.206-1.18-0.214l-1.512-0.124l0.021,0.38l-12.805-0.738l-0.007-0.153
		l-1.478-0.09c-0.801,0.083-1.414,0.698-1.483,1.477c-0.973,11.431-1.498,18.839-1.381,19.335c0.13,0.311,0.855,0.712,1.422,0.96
		l0.255-3.569l16.339,1.042l-0.242,3.41c0.4-0.11,1.146-0.386,1.394-1.042c0.194-0.545,0.87-10.859,1.395-19.522
		C301.369,62.175,301.064,61.712,300.596,61.533 M298.601,70.431l-0.09,0.055c-0.11,0.062-2.506,1.456-6.483,1.456
		c-0.303,0-0.614-0.006-0.931-0.028c-4.521-0.242-7.365-1.967-7.483-2.043l-0.117-0.069l0.552-7.669l15.076,0.96L298.601,70.431z"
        />
        <path
          fill={darkenColor}
          d="M254.263,99.816c-0.352,1.104-0.697,2.202-1.029,3.272h-7.607l-0.496-1.684
		c-0.173-0.559-0.353-1.125-0.525-1.684c1.746,0.124,3.342,0.186,4.825,0.186c0.262,0,0.532,0,0.787-0.007
		C251.481,99.919,252.841,99.885,254.263,99.816"
        />
        <path
          fill={darkenColor}
          d="M309.072,164.552c-2.292-0.656-18.763-5.584-24.809-13.089c-3.846-4.769-6.296-19.148-7.297-42.728
		c-0.041-1.05-0.075-1.802-0.096-2.147c-0.242-3.071-2.25-4.252-2.333-4.3l-0.049-0.028h-4.272l-3.306,0.338
		c0.476-1.201,1.035-2.714,1.671-4.473c0.897-0.145,1.774-0.29,2.629-0.429c3.473-0.565,6.469-1.049,8.754-1.236
		c6.005-0.496,14.468,1.733,15.704,2.071c0.035,1.934,0.359,20.764,0.863,28.282c0.255,3.755,1.388,7.496,2.485,11.114l0.29,0.953
		c1.304,4.335,2.767,8.622,4.348,12.736c0.725,1.891,1.388,3.596,2.161,5.245c0.325,0.697,0.677,1.395,1.022,2.065
		c0.897,1.746,1.829,3.555,2.222,5.535C309.065,164.49,309.065,164.524,309.072,164.552"
        />
        <path
          fill={darkenColor}
          d="M232.257,102.26h-7.303l-0.048,0.028c-0.083,0.048-2.092,1.229-2.333,4.3
		c-0.021,0.345-0.055,1.104-0.104,2.154c-0.994,23.58-3.451,37.952-7.289,42.721c-6.019,7.47-22.041,12.246-24.416,12.923
		c0.235-1.753,0.987-3.168,1.878-4.846c0.152-0.283,0.304-0.566,0.456-0.863c1.312-2.52,2.499-5.15,3.52-7.835
		c1.629-4.266,3.113-8.774,4.404-13.385l0.131-0.469c0.932-3.307,1.891-6.737,2.126-10.175c0.511-7.517,0.835-26.348,0.863-28.281
		c1.243-0.339,9.705-2.568,15.704-2.071c2.264,0.179,5.295,0.663,8.801,1.214l1.981,0.311
		C231.194,99.519,231.739,100.955,232.257,102.26"
        />
        <path
          fill="#404040"
          d="M215.869,69.575c-0.565,0.317-3.258,1.705-7.178,1.912c-3.935,0.213-6.552-1.042-7.075-1.319l-0.477-6.675
		l14.228-0.911L215.869,69.575z"
        />
        <path
          fill="#404040"
          d="M296.903,81.185l-1.974,16.712c-2.243-0.566-7.8-1.85-12.667-1.933c0.269-2.982,0.593-5.743,0.897-8.408
		c0.297-2.526,0.573-4.921,0.759-7.151C289.185,80.744,295.619,81.109,296.903,81.185"
        />
        <path
          fill="#404040"
          d="M297.476,61.119l-11.943-0.69l-0.358-12.943c5.273-16.719,9.815-31.512,10.934-35.44
		c0.089,0.483,0.151,1.022,0.206,1.532c0.035,0.283,0.07,0.559,0.104,0.821c0.166,1.202,0.863,42.295,0.869,42.715L297.476,61.119z"
        />
        <path
          fill="#404040"
          d="M284.815,47.216h-0.075l0.006,0.215c-6.854,21.744-14.937,46.704-18.313,55.209l-12.75,0.442
		c2.796-8.974,6.296-19.294,9.678-29.289c2.223-6.565,4.322-12.763,6.199-18.507l0.284-0.863
		c3.658-11.162,7.434-22.704,11.203-34.038c0.525-1.574,1.035-3.168,1.553-4.756c0.49-1.526,0.98-3.044,1.478-4.542h0.151
		l-0.006-0.214c2.533-0.953,10.996-0.628,11.493-0.035c0.07,0.11,0.125,0.242,0.18,0.387
		C295.28,13.564,290.476,29.262,284.815,47.216"
        />
        <path
          fill="#404040"
          d="M217.547,95.971c-4.867,0.076-10.424,1.353-12.661,1.926l-1.974-16.712
		c1.276-0.076,7.711-0.442,12.977-0.78c0.193,2.23,0.469,4.625,0.759,7.152C216.96,90.221,217.277,92.982,217.547,95.971"
        />
        <path
          fill="#404040"
          d="M245.172,103.074l-12.453-0.808c-6.178-15.532-16.463-49.756-17.651-54.429l-0.014-0.048l0.007-0.393
		h-0.124L203.92,11.218c0.055-0.138,0.11-0.269,0.173-0.372c0.504-0.601,8.96-0.926,11.5,0.027l-0.007,0.179h0.104
		c1.035,3.113,2.071,6.22,3.106,9.333c3.769,11.335,7.552,22.876,11.204,34.039l0.282,0.863
		c3.403,10.395,6.896,21.757,10.278,32.754c1.408,4.59,2.803,9.125,4.156,13.481L245.172,103.074z"
        />
        <path
          fill="#404040"
          d="M214.627,47.844l-0.345,12.584l-11.942,0.69l0.186-4.011c0.007-0.414,0.704-41.507,0.87-42.708
		c0.035-0.262,0.062-0.538,0.097-0.822c0.062-0.524,0.124-1.083,0.221-1.58L214.627,47.844z"
        />
        <path
          fill="#010101"
          d="M284.05,62.133l-0.552,7.669l0.117,0.069c0.117,0.076,2.961,1.802,7.483,2.043
		c0.318,0.021,0.628,0.028,0.931,0.028c3.976,0,6.372-1.394,6.483-1.456l0.09-0.055l0.525-7.338L284.05,62.133z M298.193,70.168
		c-0.518,0.276-3.133,1.532-7.068,1.318c-3.928-0.207-6.613-1.595-7.18-1.911l0.497-6.993l14.227,0.911L298.193,70.168z"
        />
        <path
          fill="#404040"
          d="M298.67,63.493l-0.476,6.675c-0.518,0.276-3.133,1.532-7.069,1.318c-3.928-0.207-6.613-1.595-7.179-1.911
		l0.497-6.993L298.67,63.493z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M236.07,247.41c1.035-1.211,3.037-3.565,3.951-4.641l0.46-26.313c-0.098,0.087-0.191,0.17-0.278,0.248
		c-0.24,0.214-0.44,0.392-0.581,0.517c-0.072,0.064-0.134,0.118-0.178,0.157c-0.443,0.387-0.942,0.578-1.484,0.571
		c-0.031,0-0.061-0.001-0.092-0.003l-38.75-0.616l-0.857-0.019l-0.602-0.605c-0.053-0.054-0.513-0.507-1.129-1.115l-0.46,26.453
		c0.381,0.467,0.946,1.162,1.533,1.882l0.636,0.781c0.833,1.02,1.367,1.677,1.715,2.103L236.07,247.41z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M236.653,248.703c0.897-1.047,3.873-4.543,4.644-5.454l0.519-29.716c-0.403,0.362-0.716,0.642-0.724,0.65
		c-0.634,0.569-1.268,1.137-1.744,1.562c-0.238,0.213-0.437,0.389-0.578,0.514c-0.07,0.062-0.126,0.113-0.167,0.147
		c-0.085,0.075-0.301,0.262-0.625,0.258c-0.018-0.001-0.037-0.001-0.056-0.003l-38.772-0.618l-0.344-0.007l-0.24-0.241
		c-0.065-0.065-1.875-1.852-3.268-3.218l-0.521,29.912c0.331,0.409,1.06,1.303,1.825,2.24l0.639,0.785
		c1.231,1.509,1.81,2.219,2.093,2.569L236.653,248.703z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M237.011,213.683c0.81-0.723,3.78-3.565,3.78-3.565l0.204-12.061l-44.575-0.722l-0.207,12.177c0.038,0.037,0.077,0.075,0.118,0.115
		c0.443,0.431,1.026,1.002,1.687,1.652c0.652,0.641,1.353,1.332,1.84,1.812L237.011,213.683z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M237.683,214.977c0.701-0.621,2.807-2.512,4.177-3.743l0.393-0.389l0.24-14.049l-47.143-0.763l-0.24,14.018
		c0.135,0.13,0.311,0.3,0.517,0.5c0.442,0.429,1.023,0.998,1.682,1.646c0.844,0.829,1.767,1.74,2.204,2.172L237.683,214.977z"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          x1="239.691"
          y1="226.918"
          x2="196.912"
          y2="226.326"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M265.644,247.41c-1.034-1.211-3.037-3.565-3.951-4.641l-0.46-26.313c0.097,0.087,0.191,0.17,0.278,0.248
		c0.24,0.214,0.439,0.392,0.581,0.517c0.073,0.064,0.135,0.118,0.178,0.157c0.443,0.387,0.943,0.578,1.485,0.571
		c0.03,0,0.061-0.001,0.092-0.003l38.75-0.616l0.858-0.019l0.601-0.605c0.055-0.054,0.514-0.507,1.129-1.115l0.461,26.453
		c-0.381,0.467-0.947,1.162-1.533,1.882l-0.636,0.781c-0.833,1.02-1.368,1.677-1.716,2.103L265.644,247.41z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M265.061,248.703c-0.897-1.047-3.873-4.543-4.644-5.454l-0.519-29.716c0.402,0.362,0.715,0.642,0.723,0.65
		c0.634,0.569,1.268,1.137,1.744,1.562c0.238,0.213,0.437,0.389,0.578,0.514c0.07,0.062,0.127,0.113,0.168,0.147
		c0.085,0.075,0.301,0.262,0.625,0.258c0.019-0.001,0.038-0.001,0.056-0.003l38.773-0.618l0.344-0.007l0.24-0.241
		c0.064-0.065,1.874-1.852,3.268-3.218l0.521,29.912c-0.331,0.409-1.06,1.303-1.825,2.24l-0.639,0.785
		c-1.232,1.509-1.811,2.219-2.094,2.569L265.061,248.703z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M264.703,213.683c-0.81-0.723-3.78-3.565-3.78-3.565l-0.204-12.061l44.575-0.722l0.208,12.177
		c-0.038,0.037-0.078,0.075-0.118,0.115c-0.443,0.431-1.026,1.002-1.688,1.652c-0.652,0.641-1.353,1.332-1.839,1.812
		L264.703,213.683z"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M264.031,214.977c-0.702-0.621-2.807-2.512-4.177-3.743l-0.393-0.389l-0.24-14.049l47.143-0.763l0.24,14.018
		c-0.135,0.13-0.311,0.3-0.518,0.5c-0.441,0.429-1.022,0.998-1.681,1.646c-0.844,0.829-1.768,1.74-2.204,2.172L264.031,214.977z"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          x1="262.024"
          y1="226.918"
          x2="304.803"
          y2="226.326"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M310.252,184.342c0,0-2.652,0.019-6.042,0.066l-4.142,0.075c-2.597,0.037-7.645,0.08-10.86,0.128l-10.426,0.157
		c-9.886,0.152-20.497,0.324-28.784,0.48c-8.363,0.158-20.179-0.015-30.15-0.207l-9.474-0.173c-3.159-0.079-7.528-0.16-10.071-0.233
		l-3.991-0.15c-3.262-0.102-5.945-0.142-5.945-0.142"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M310.252,188.492c0,0-2.652,0.018-6.042,0.066l-4.142,0.075c-2.597,0.037-7.645,0.08-10.86,0.128l-10.426,0.156
		c-9.886,0.152-20.497,0.324-28.784,0.48c-8.363,0.157-20.179-0.016-30.15-0.207l-9.474-0.174
		c-3.159-0.079-7.528-0.159-10.071-0.233l-3.991-0.15c-3.262-0.102-5.945-0.142-5.945-0.142"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8539,0.6406"
          d="
		M184.807,475.471c0,0,22,6.488,49.829,0.181"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8539,0.6406"
          d="
		M315.193,475.471c0,0-22.12,6.488-49.949,0.181"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          x1="250.963"
          y1="256.895"
          x2="250.963"
          y2="257.215"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.6406,0.6406"
          d="
		M254.44,279.352c0.286-6.257,0.687-15.872,0.521-17.417c-0.249-2.319-3.392-3.801-4.857-3.364h-0.064
		c-1.465-0.437-4.607,1.044-4.856,3.364c-0.164,1.523,0.224,10.905,0.509,17.165"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.6406,0.6406"
          d="
		M246.548,272.804v-8.676c0-1.115,0.416-2.203,1.202-2.992c0.541-0.543,1.222-0.837,2.205-0.848"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.6406,0.6406"
          d="
		M253.57,272.88l-0.121-8.797c0-1.115-0.416-2.202-1.202-2.992c-0.541-0.543-1.221-0.837-2.204-0.848"
        />

        <line
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          x1="251.473"
          y1="190.051"
          x2="251.473"
          y2="255.705"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.3106"
          strokeMiterlimit="10"
          strokeDasharray="0.8346,0.8339"
          d="
		M191.292,166.249c-0.008-0.101,1.236-0.265,1.232-0.361c4.199-1.258,18.641-5.998,24.513-13.286
		c5.528-6.865,7.036-28.276,7.69-43.785l0.04-0.889c0.024-0.561,0.042-0.973,0.06-1.196c0.113-1.457,0.781-2.292,1.177-2.667h6.565
		c11.183,0.432,22.75,0.403,34.629,0h7.14c0.409,0.387,1.067,1.22,1.178,2.66c0.019,0.231,0.037,0.648,0.062,1.216l0.039,0.875
		c1.02,24.3,3.536,38.624,7.69,43.785c6.168,7.656,22.363,12.728,25.622,13.673"
        />
        <path
          fill="#010101"
          d="M316.631,282.702c-0.187-8.201-0.367-16.084-0.518-23.236c-0.063-2.995-0.125-5.861-0.173-8.566
		c-0.628-31.822-2.816-51.234-4.653-58.792c-0.339-1.387-0.567-2.837-0.663-4.294c-0.049-0.67-0.062-1.353-0.084-2.009
		c-0.014-0.641-0.028-1.311-0.069-1.967c-0.193-2.927-0.297-5.902-0.4-8.787l-0.035-1.069c-0.028-0.815-0.041-1.657-0.048-2.5
		c-0.028-2.367-0.055-4.818-0.512-7.102c-0.407-2.036-1.353-3.873-2.264-5.647c-0.345-0.67-0.697-1.36-1.015-2.05
		c-0.766-1.643-1.429-3.334-2.154-5.225c-1.574-4.1-3.03-8.373-4.335-12.701l-0.29-0.953c-1.083-3.597-2.209-7.309-2.464-11.018
		c-0.532-7.883-0.863-28.218-0.863-28.419l-0.008-0.158l-0.152-0.048c-0.013,0-0.228-0.062-0.594-0.159l1.843-15.601l0.186-1.615
		l-0.221-0.014c-0.075-0.008-7.538-0.428-13.412-0.808l-0.214-0.014l-0.014,0.207c-0.186,2.292-0.476,4.748-0.773,7.352
		c-0.311,2.678-0.628,5.446-0.904,8.456c-0.65-0.007-1.292,0.021-1.906,0.069c-2.306,0.186-5.308,0.676-8.787,1.242
		c-0.78,0.125-1.581,0.257-2.402,0.387c3.887-10.879,10.347-30.877,16.042-48.928l0.228,8.373l0.09,3.148l-1.463-0.09l-0.007,0.104
		l-0.028-0.104c-1.001,0.09-1.788,0.877-1.878,1.864c-0.732,8.636-1.559,19.024-1.353,19.528c0.276,0.67,1.774,1.256,1.94,1.318
		l0.27,0.104l0.269-3.728l15.483,0.987l-0.255,3.527l0.263-0.041c0.062-0.008,1.56-0.222,2.001-1.361
		c0.249-0.656,1.078-13.965,1.423-19.653c0.041-0.697-0.367-1.333-1.022-1.581c-0.393-0.145-0.841-0.228-1.304-0.242l-1.14-0.083
		l-0.413-0.041l-0.166-3.665c-0.028-1.698-0.711-41.535-0.877-42.763c-0.035-0.255-0.069-0.532-0.097-0.808
		c-0.13-1.118-0.262-2.271-0.67-2.92c-0.621-0.973-9.933-1.035-12.156-0.084l-0.09,0.042l-0.028-0.007c0,0.007,0,0.014-0.007,0.021
		l-0.006,0.007l0.006,0.007c-0.545,1.615-1.069,3.258-1.601,4.901c-0.511,1.587-1.029,3.182-1.546,4.749
		c-3.776,11.341-7.552,22.883-11.21,34.045l-0.277,0.863c-1.884,5.736-3.982,11.935-6.206,18.5
		c-2.941,8.691-5.97,17.636-8.553,25.727c-1.477,0.076-2.878,0.11-4.183,0.09c-1.746,0.028-3.631-0.035-5.749-0.186
		c-1.146-3.707-2.313-7.51-3.5-11.369c-3.382-10.996-6.875-22.365-10.278-32.761l-0.283-0.863
		c-3.652-11.162-7.435-22.704-11.204-34.045c-1.063-3.182-2.119-6.364-3.182-9.554V10.59l-0.132-0.063
		c-2.216-0.952-11.535-0.89-12.148,0.084c-0.415,0.649-0.545,1.802-0.67,2.92c-0.035,0.283-0.069,0.552-0.103,0.808
		c-0.166,1.229-0.843,41.065-0.87,42.757l-0.173,3.672l-1.539,0.124c-0.476,0.014-0.918,0.097-1.318,0.242
		c-0.648,0.248-1.056,0.884-1.015,1.581c0.339,5.688,1.167,18.997,1.415,19.653c0.442,1.139,1.94,1.353,2.003,1.361l0.262,0.041
		l-0.249-3.527l15.483-0.987l0.263,3.728l0.269-0.104c0.173-0.062,1.664-0.649,1.947-1.318c0.207-0.505-0.628-10.893-1.361-19.528
		c-0.083-0.987-0.87-1.773-1.891-1.864h-0.021l-1.463,0.09l0.304-10.99c1.961,7.034,9.705,32.609,15.449,48.266l-1.747-0.277
		c-3.52-0.559-6.558-1.035-8.835-1.222c-0.615-0.048-1.25-0.069-1.906-0.069c-0.269-3.01-0.587-5.778-0.897-8.456
		c-0.303-2.603-0.587-5.06-0.773-7.352l-0.02-0.207l-0.208,0.014c-5.881,0.38-13.336,0.8-13.412,0.808l-0.228,0.014l2.036,17.216
		c-0.373,0.097-0.586,0.159-0.601,0.159l-0.152,0.048v0.158c-0.006,0.202-0.331,20.536-0.869,28.419
		c-0.228,3.397-1.18,6.8-2.106,10.093l-0.131,0.462c-1.291,4.604-2.767,9.098-4.397,13.35c-1.014,2.665-2.194,5.288-3.5,7.786
		c-0.152,0.297-0.303,0.587-0.448,0.863c-1.229,2.305-2.203,4.128-1.982,6.979c0.359,4.687,0.311,9.561-0.138,15.352
		c-0.076,0.994-0.117,2.002-0.159,2.975c-0.041,1.042-0.082,2.112-0.173,3.168c-0.173,2.071-0.483,4.135-0.917,6.13l-0.083,0.366
		c-2.5,10.893-4.274,32.049-4.757,56.59c-0.179,9.188-0.435,20.191-0.697,31.843c-0.959,41.81-2.036,89.206-0.925,94.77
		c0.545,2.754,0.642,18.32,0.752,36.344c0.173,28.764,0.387,64.562,2.513,70.312l0.035,0.097l0.103,0.033
		c0.131,0.042,9.306,2.796,23.532,2.796c7.158,0,15.594-0.697,24.803-2.789c0.22,0,0.22,0,0.414-3.541
		c0.117-2.126,0.283-5.163,0.469-8.801c0.387-7.289,0.884-17.009,1.381-26.721c0.988-19.439,1.967-38.87,1.967-38.87
		c0.028-0.573,2.437-57.867,1.837-81.599c0.801-18.079,5.032-35.591,5.087-35.812c0.4-10.624,1.98-26.466,4.666-26.652
		c2.63,0.186,4.198,15.331,4.646,25.976c-0.007,0.124-0.007,0.214-0.007,0.228h0.021c0.007,0.166,0.014,0.331,0.021,0.489
		c0.041,0.18,4.272,17.693,5.08,35.758c-0.607,23.746,1.802,81.04,1.83,81.613c0,0,0.98,19.432,1.967,38.87
		c0.497,9.712,1.001,19.432,1.381,26.721c0.193,3.638,0.352,6.675,0.469,8.801c0.193,3.541,0.2,3.541,0.373,3.541
		c9.229,2.092,17.678,2.789,24.844,2.789c14.234,0,23.401-2.754,23.54-2.796l0.096-0.033l0.041-0.097
		c2.126-5.75,2.341-41.555,2.513-70.32c0.103-18.024,0.2-33.583,0.752-36.337C318.675,371.949,317.59,324.533,316.631,282.702
		 M283.159,87.557c0.296-2.526,0.573-4.922,0.759-7.151c5.267,0.338,11.7,0.703,12.985,0.78l-1.975,16.712
		c-2.243-0.567-7.8-1.85-12.666-1.933C282.53,92.982,282.855,90.221,283.159,87.557 M271.21,97.697
		c3.472-0.566,6.468-1.049,8.754-1.236c6.005-0.497,14.468,1.732,15.704,2.071c0.034,1.933,0.358,20.764,0.863,28.281
		c0.255,3.755,1.387,7.497,2.484,11.114l0.29,0.953c1.305,4.335,2.768,8.622,4.349,12.736c0.726,1.891,1.388,3.596,2.161,5.246
		c0.325,0.697,0.676,1.394,1.022,2.064c0.897,1.746,1.83,3.555,2.223,5.535c0.007,0.029,0.007,0.063,0.014,0.09
		c-2.292-0.656-18.763-5.584-24.81-13.089c-3.845-4.769-6.295-19.148-7.296-42.728c-0.041-1.05-0.076-1.802-0.097-2.147
		c-0.241-3.072-2.25-4.253-2.333-4.3l-0.048-0.028h-4.272l-3.307,0.338c0.476-1.201,1.035-2.713,1.671-4.473
		C269.477,97.98,270.354,97.835,271.21,97.697 M297.924,61.574l-0.021-0.38l1.512,0.124c0.428,0.007,0.829,0.083,1.18,0.214
		c0.469,0.179,0.773,0.642,0.739,1.153c-0.525,8.663-1.202,18.976-1.395,19.521c-0.248,0.656-0.993,0.932-1.394,1.042l0.241-3.41
		l-16.339-1.042l-0.255,3.569c-0.566-0.248-1.291-0.649-1.421-0.959c-0.117-0.497,0.407-7.904,1.381-19.336
		c0.068-0.779,0.683-1.394,1.483-1.477l1.478,0.09l0.006,0.152L297.924,61.574z M296.108,12.046c0.09,0.483,0.152,1.022,0.207,1.532
		c0.035,0.284,0.07,0.56,0.104,0.822c0.166,1.201,0.863,42.294,0.87,42.715l0.187,4.004l-11.943-0.69l-0.359-12.943
		C290.448,30.767,294.99,15.974,296.108,12.046 M263.361,73.792c2.223-6.565,4.322-12.763,6.199-18.507l0.283-0.863
		c3.659-11.163,7.434-22.704,11.203-34.038c0.525-1.575,1.035-3.168,1.553-4.756c0.49-1.526,0.98-3.044,1.478-4.542h0.151
		l-0.006-0.215c2.533-0.952,10.996-0.627,11.493-0.034c0.07,0.11,0.125,0.242,0.18,0.387c-0.615,2.34-5.419,18.037-11.08,35.992
		h-0.075l0.006,0.214c-6.854,21.744-14.937,46.705-18.313,55.209l-12.75,0.442C256.479,94.108,259.979,83.788,263.361,73.792
		 M249.431,99.906c0.262,0,0.532,0,0.787-0.007c1.263,0.02,2.624-0.014,4.045-0.083c-0.352,1.104-0.697,2.203-1.029,3.272h-7.607
		l-0.496-1.684c-0.173-0.559-0.353-1.125-0.525-1.684C246.352,99.844,247.948,99.906,249.431,99.906 M202.526,57.108
		c0.008-0.414,0.704-41.507,0.87-42.708c0.035-0.262,0.062-0.538,0.096-0.822c0.062-0.524,0.124-1.083,0.222-1.58l10.913,35.847
		l-0.345,12.585l-11.942,0.69L202.526,57.108z M216.187,60.594c0.773,0.076,1.408,0.704,1.478,1.477
		c0.966,11.432,1.498,18.839,1.387,19.322c-0.138,0.324-0.869,0.725-1.436,0.973l-0.255-3.569l-16.332,1.042l0.242,3.41
		c-0.4-0.11-1.147-0.386-1.402-1.035c-0.193-0.552-0.869-10.865-1.394-19.528c-0.028-0.511,0.269-0.973,0.745-1.153
		c0.353-0.131,0.753-0.207,1.188-0.214l1.153-0.083l0.345-0.035l-0.015,0.373l12.805-0.739v-0.152L216.187,60.594z M215.068,47.838
		l-0.014-0.048l0.007-0.393h-0.124L203.92,11.217c0.056-0.137,0.111-0.269,0.173-0.372c0.504-0.601,8.96-0.925,11.501,0.027
		l-0.008,0.18h0.104c1.035,3.113,2.071,6.22,3.106,9.333c3.769,11.335,7.552,22.875,11.204,34.038l0.282,0.863
		c3.404,10.396,6.896,21.758,10.279,32.755c1.408,4.59,2.802,9.125,4.155,13.481l0.456,1.553l-12.453-0.808
		C226.541,86.735,216.256,52.511,215.068,47.838 M202.913,81.185c1.276-0.077,7.71-0.442,12.977-0.78
		c0.194,2.23,0.469,4.625,0.759,7.151c0.311,2.665,0.628,5.426,0.898,8.415c-4.867,0.076-10.424,1.353-12.661,1.926L202.913,81.185z
		 M192.642,159.54c0.151-0.283,0.303-0.566,0.455-0.863c1.312-2.52,2.499-5.15,3.52-7.835c1.63-4.266,3.113-8.774,4.404-13.385
		l0.132-0.469c0.931-3.306,1.891-6.737,2.125-10.175c0.511-7.517,0.836-26.348,0.863-28.281c1.243-0.339,9.705-2.568,15.704-2.071
		c2.264,0.179,5.295,0.663,8.801,1.214l1.981,0.311c0.566,1.532,1.111,2.968,1.629,4.273h-7.303l-0.048,0.028
		c-0.082,0.048-2.091,1.229-2.333,4.3c-0.02,0.345-0.055,1.104-0.103,2.154c-0.995,23.58-3.451,37.952-7.29,42.721
		c-6.019,7.47-22.041,12.246-24.416,12.923C190.999,162.633,191.751,161.218,192.642,159.54 M190.418,184.667
		c0.041-0.973,0.083-1.981,0.159-2.961c0.449-5.812,0.497-10.713,0.139-15.421c-0.042-0.511-0.028-0.987,0.006-1.443
		c1.74-0.49,18.542-5.356,24.789-13.109c5.881-7.303,7.013-34.149,7.386-42.971c0.048-1.049,0.075-1.809,0.103-2.147
		c0.2-2.582,1.788-3.741,2.071-3.928h7.497l12.737,0.821v0.007h8.241l0.007-0.007l12.708-0.442l-0.007,0.028l3.983-0.407h4.135
		c0.283,0.186,1.871,1.346,2.071,3.928c0.028,0.338,0.055,1.098,0.104,2.14c1.002,23.67,3.486,38.132,7.387,42.977
		c6.343,7.876,23.925,12.922,25.223,13.288c0.351,2.085,0.379,4.307,0.407,6.468c0.006,0.849,0.02,1.684,0.048,2.513l0.035,1.063
		c0.103,2.886,0.206,5.867,0.4,8.801c0.041,0.649,0.062,1.312,0.075,1.954c0,0.117,0.007,0.242,0.007,0.366
		c-0.559,0.007-2.954,0.028-5.922,0.069l-4.142,0.076c-1.195,0.014-2.907,0.035-4.722,0.055c-2.133,0.021-4.404,0.041-6.137,0.069
		l-10.423,0.159c-12.018,0.179-21.71,0.345-28.786,0.476c-7.214,0.138-16.995,0.09-29.068-0.145l-10.548-0.235
		c-1.387-0.035-3.003-0.069-4.597-0.104c-2.043-0.041-4.046-0.09-5.475-0.131l-3.989-0.145c-2.831-0.09-5.364-0.138-5.972-0.145
		C190.377,185.675,190.398,185.164,190.418,184.667 M244.91,288.907c-0.048,0.173-4.293,17.727-5.094,35.867
		c0.601,23.725-1.809,81.005-1.829,81.578c-0.041,0.753-3.727,73.903-4.004,77.569c-26.376,5.943-46.318,0.462-47.92,0
		c-2.064-5.985-2.277-41.502-2.45-70.072c-0.104-18.044-0.2-33.631-0.76-36.42c-1.104-5.515,0.028-54.954,0.939-94.68
		c0.262-11.652,0.512-22.655,0.697-31.843c0.483-24.512,2.258-45.635,4.742-56.5l0.083-0.373c0.442-2.009,0.752-4.093,0.932-6.185
		c0.035-0.407,0.055-0.815,0.076-1.215c0.559,0.007,3.12,0.055,5.978,0.145l3.997,0.146c1.429,0.041,3.438,0.088,5.481,0.13
		c1.588,0.035,3.21,0.069,4.59,0.104l10.548,0.235c7.634,0.145,14.351,0.222,20.087,0.222c3.251,0,6.178-0.021,8.788-0.07v69.505
		c-1.002-0.2-2.43,0.173-3.652,0.987c-1.298,0.863-2.085,2.016-2.216,3.251c-0.298,2.747,0.876,26.246,0.925,27.246l0.075-0.007
		C244.917,288.68,244.91,288.811,244.91,288.907 M250.011,261.882l-0.014,0.214l-0.006-0.214
		c-3.114,0.166-4.419,15.179-4.874,22.855c-0.331-6.972-0.966-21.351-0.752-23.401c0.166-1.484,1.34-2.471,2.023-2.927
		c1.18-0.78,2.609-1.146,3.479-0.89l0.028,0.014l0.173-0.014c0.87-0.262,2.299,0.11,3.479,0.89c0.683,0.456,1.858,1.443,2.016,2.927
		c0.215,1.995-0.38,15.607-0.718,22.78C254.353,276.261,253.034,262.041,250.011,261.882 M317.142,377.43
		c-0.559,2.789-0.648,18.375-0.759,36.42c-0.173,28.57-0.387,64.087-2.45,70.072c-1.595,0.462-21.51,5.936-47.914,0.006
		c-0.276-3.59-3.969-76.822-4.003-77.575c-0.028-0.572-2.437-57.852-1.837-81.592c-0.801-18.127-5.046-35.681-5.087-35.812
		c0-0.104-0.006-0.249-0.014-0.414c0.048-0.89,0.981-19.521,0.981-25.603c0-0.766-0.014-1.332-0.049-1.643
		c-0.131-1.236-0.918-2.388-2.216-3.251c-1.194-0.794-2.582-1.167-3.576-1.001v-69.498c7.062-0.138,16.67-0.298,28.565-0.476
		l10.43-0.159c1.733-0.028,4.004-0.048,6.137-0.076c1.815-0.014,3.527-0.035,4.722-0.048l4.142-0.076
		c2.981-0.041,5.39-0.062,5.929-0.069c0.014,0.4,0.028,0.808,0.055,1.208c0.104,1.484,0.331,2.954,0.67,4.37
		c1.836,7.531,4.017,26.907,4.646,58.695c0.048,2.706,0.11,5.578,0.173,8.566c0.151,7.151,0.338,15.034,0.524,23.235
		C317.114,322.448,318.247,371.915,317.142,377.43"
        />
        <path
          fill="#010101"
          d="M194.526,194.952h-0.222l-0.269,15.821l0.193-0.089c0.007,0.006,0.021,0.02,0.028,0.027l-0.552,32.043
		c-0.014,0.097-0.014,0.097,2.485,3.168c1.167,1.429,2.484,3.044,2.526,3.086l0.055,0.138l38.263,0.635h0.055l0.048-0.028
		c0.083-0.041,5.205-6.068,5.225-6.185l0.559-31.857c0.193-0.173,0.318-0.29,0.331-0.297l0.055-0.062l0.262-15.38l0.007-0.228
		L194.526,194.952z M241.921,243.473c-0.449,0.531-4.419,5.197-4.984,5.86l-37.904-0.635c-0.187-0.235-0.752-0.925-2.492-3.058
		c-1.015-1.243-2.147-2.637-2.388-2.934l0.545-31.567c1.243,1.194,4.073,3.99,4.3,4.225l0.069,0.062l38.919,0.621v-0.013
		c0.179-0.056,0.649-0.477,2.692-2.306c0.021-0.021,1.035-0.932,1.788-1.601L241.921,243.473z M242.867,211.16
		c-0.076,0.062-0.2,0.179-0.373,0.331h-0.021v0.021c-1.146,1.029-4.1,3.679-4.563,4.087l-38.656-0.614
		c-0.283-0.283-1.394-1.381-2.375-2.346c-1.491-1.464-2.105-2.065-2.388-2.306l0.255-14.924l48.375,0.781L242.867,211.16z"
        />
        <path
          fill="#010101"
          d="M308.016,242.775l-0.558-32.064c0.007-0.007,0.02-0.021,0.028-0.027l0.193,0.089l-0.269-15.822
		l-49.045,0.795h-0.228l0.268,15.607l0.055,0.062c0.014,0.007,0.145,0.124,0.339,0.297l0.558,31.891
		c0.014,0.076,5.136,6.109,5.219,6.15l0.048,0.028l38.174-0.635l0.117,0.041l0.055-0.131c0.062-0.083,1.36-1.671,2.498-3.072
		C308.023,242.851,308.023,242.851,308.016,242.775 M259.219,211.491c-0.173-0.152-0.303-0.269-0.373-0.331l-0.255-14.972
		l48.375-0.781l0.255,14.924c-0.282,0.242-0.897,0.841-2.381,2.306c-0.988,0.966-2.098,2.063-2.381,2.346l-38.656,0.614
		c-0.462-0.407-3.424-3.065-4.564-4.087v-0.021H259.219z M305.123,245.702c-1.711,2.092-2.257,2.768-2.444,2.996l-37.903,0.635
		c-0.567-0.663-4.508-5.295-4.977-5.854l-0.545-31.353c0.746,0.676,1.76,1.581,1.781,1.601c2.043,1.829,2.513,2.25,2.691,2.306
		v0.013l38.829-0.621h0.09l0.07-0.062c0.228-0.235,3.064-3.03,4.3-4.231l0.552,31.574
		C307.325,243.003,306.159,244.432,305.123,245.702"
        />
      </g>
    </svg>
  );
}
